import React from "react";

const iconClasses = "h-5 w-5 flex-none";

const icons = {
  github: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={iconClasses}
      fill="currentColor"
    >
      <path d="M12 .5C5.65.5.5 5.65.5 12c0 5.08 3.29 9.4 7.86 10.92.58.1.79-.25.79-.56 0-.27-.01-1.17-.02-2.12-3.2.7-3.88-1.35-3.88-1.35-.52-1.33-1.28-1.68-1.28-1.68-1.04-.72.08-.71.08-.71 1.15.08 1.75 1.18 1.75 1.18 1.02 1.75 2.67 1.25 3.32.96.1-.74.4-1.25.73-1.54-2.55-.29-5.24-1.27-5.24-5.67 0-1.25.45-2.27 1.17-3.07-.12-.29-.51-1.46.11-3.04 0 0 .96-.31 3.14 1.17a10.9 10.9 0 0 1 5.72 0c2.18-1.48 3.13-1.17 3.13-1.17.63 1.58.24 2.75.12 3.04.73.8 1.17 1.82 1.17 3.07 0 4.41-2.7 5.37-5.27 5.66.42.36.78 1.06.78 2.15 0 1.56-.01 2.81-.01 3.19 0 .31.21.67.8.56A11.52 11.52 0 0 0 23.5 12C23.5 5.65 18.35.5 12 .5Z" />
    </svg>
  ),
  linkedin: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={iconClasses}
      fill="currentColor"
    >
      <path d="M4.98 3.5A2.48 2.48 0 1 0 5 8.46 2.48 2.48 0 0 0 4.98 3.5ZM3 9.5h4v11H3v-11Zm7 0h3.83v1.5h.05c.53-.95 1.85-1.95 3.8-1.95 4.07 0 4.82 2.54 4.82 5.85v5.6h-4v-4.96c0-1.18-.02-2.7-1.65-2.7-1.65 0-1.9 1.29-1.9 2.62v5.04h-4v-11Z" />
    </svg>
  ),
  mail: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={iconClasses}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m4 7 8 6 8-6" />
    </svg>
  ),
  medium: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={iconClasses}
      fill="currentColor"
    >
      <path d="M4.37 7.28a.66.66 0 0 0-.2-.56L2.7 4.97V4.7h4.58l3.54 7.77 3.12-7.77h4.37v.27l-1.26 1.2a.37.37 0 0 0-.14.36v8.94c0 .14.05.28.16.37l1.23 1.19v.27h-6.2v-.27l1.28-1.24c.13-.13.13-.17.13-.37V8.17L9.95 17.5h-.48L5.36 8.17v6.13c-.03.27.06.54.24.73l1.66 2.02v.27H2.54v-.27l1.66-2.02a1.04 1.04 0 0 0 .2-.73V7.28h-.03Z" />
    </svg>
  ),
};

const SocialLinks = ({ links, stacked = false }) => {
  return (
    <ul
      className={
        stacked
          ? "space-y-3"
          : "flex flex-wrap items-center gap-3"
      }
    >
      {links.map((link) => (
        <li key={link.label}>
          <a
            href={link.href}
            target={link.href.startsWith("mailto:") ? undefined : "_blank"}
            rel={link.href.startsWith("mailto:") ? undefined : "noreferrer"}
            className={
              stacked
                ? "group flex items-center justify-between rounded-2xl border border-stone-200 bg-stone-50 px-4 py-3 text-sm text-stone-700 transition hover:border-stone-300 hover:bg-white dark:border-stone-800 dark:bg-stone-900 dark:text-stone-200 dark:hover:border-stone-700 dark:hover:bg-stone-950"
                : "text-sm text-stone-700 transition hover:text-stone-950 dark:text-stone-200 dark:hover:text-stone-50"
            }
            aria-label={link.label}
          >
            {stacked ? (
              <>
                <span className="flex items-center gap-3">
                  {icons[link.icon]}
                  <span className="font-medium">{link.label}</span>
                </span>
                <span className="ml-4 text-xs text-stone-500 dark:text-stone-400">
                  {link.shortLabel}
                </span>
              </>
            ) : (
              <span className="flex items-center gap-2">
                {icons[link.icon]}
                <span className="font-medium">{link.label}</span>
              </span>
            )}
          </a>
        </li>
      ))}
    </ul>
  );
};

export default SocialLinks;
